
<section class="flex justify-content-center mt-4">
    <div class="card-table col-12">
        <div>
            <CustomTitle [title]="'msg.panelDePQRSD' | translate"
                         styleClass="mt-4 font-23  text-uppercase font-principal app-title-page-color font-medium mb-0"/>
        </div>
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)" class="w-full">
            <p-tabPanel [header]="'common.tipos' | translate">
                <app-pqrsd-tipos></app-pqrsd-tipos>
            </p-tabPanel>
            <p-tabPanel [header]="'common.actividades' | translate">
                <app-pqrsd-actividades></app-pqrsd-actividades>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
